import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@emotion/react";
import MobileMenu from "./dashboard-page-components/MobileMenu";



function NavBar() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <AppBar position="static">
      <Toolbar sx={{ backgroundColor: "white" }}>
        <Box
          sx={{ width: 250, margin: 2 }}
          component="img"
          src="https://firebasestorage.googleapis.com/v0/b/gto-moscow-sport.appspot.com/o/moscow.png?alt=media&token=3d171ed4-eb9d-4dbd-aff6-d6f87df630bf"
        />

        <Typography component="div" sx={{ flexGrow: 1, fontSize: 20 }} />

        {matches ? (
          <>
            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto.moscow.sport/#rec358963142"
            >
              О ПРОЕКТЕ
            </Link>

            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto.moscow.sport/#rec359015806"
            >
              ПРИЗЫ
            </Link>
            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto.moscow.sport/#rec358972049"
            >
              РАСПИСАНИЕ
            </Link>

            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto.moscow.sport/#rec359297804"
            >
              АКТИВНОСТИ
            </Link>
            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto.moscow.sport/#rec358978095"
            >
              КАК НАС НАЙТИ
            </Link>
            <Link
              sx={{
                fontSize: "20px",
                color: "#eb3333",
                marginRight: "30px",
                letterSpacing: "1px",
              }}
              fontFamily="Mossport"
              underline="none"
              href="https://gto-moscow-sport.web.app/"
            >
              ЛИЧНЫЙ КАБИНЕТ
            </Link>
          </>
        ) : <MobileMenu/>}
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
